import {
  IntakeSession,
  WizardAction,
  WizardState,
} from '@/app/(intakeFormV2)/intake-v2/types';
import { sanitizeMembers } from '@/app/(intakeFormV2)/intake-v2/utils/sanitizeMembers';
import { intakeInitialWizardState } from './WizardProvider';

export const restoreFromSession = (session: IntakeSession): WizardState => {
  const formData = session.formData ?? {};

  if (formData.members) {
    formData.members = sanitizeMembers(formData.members);
  }

  return {
    sessionId: session.sessionId,
    currentStepIndex: 0, // Will be calculated by navigation hook
    completedSteps: session.completedSteps ?? [],
    formData,
    leadId: session.leadId || null,
    contactId: session.contactId || null,
    accountId: session.accountId || null,
    opportunityId: session.opportunityId || null,
    isLoading: false,
    isSaving: false,
    error: null,
  };
};

export const wizardReducer = (
  state: WizardState,
  action: WizardAction
): WizardState => {
  switch (action.type) {
    case 'SET_SESSION_ID':
      return { ...state, sessionId: action.payload };

    case 'SET_FORM_DATA':
      return {
        ...state,
        formData: { ...state.formData, ...action.payload },
      };

    case 'SET_CURRENT_STEP':
      return { ...state, currentStepIndex: action.payload };

    case 'COMPLETE_STEP':
      if (state.completedSteps.includes(action.payload)) {
        return state;
      }
      return {
        ...state,
        completedSteps: [...state.completedSteps, action.payload],
      };

    case 'SET_LEAD_ID':
      return { ...state, leadId: action.payload };

    case 'SET_CONTACT_ID':
      return { ...state, contactId: action.payload };

    case 'SET_ACCOUNT_ID':
      return { ...state, accountId: action.payload };

    case 'SET_OPPORTUNITY_ID':
      return { ...state, opportunityId: action.payload };

    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };

    case 'SET_SAVING':
      return { ...state, isSaving: action.payload };

    case 'SET_ERROR':
      return { ...state, error: action.payload };

    case 'RESTORE_SESSION':
      return restoreFromSession(action.payload);

    case 'RESET':
      return intakeInitialWizardState;

    default:
      return state;
  }
};
